import { profileStorage, tokenStorage } from '@/services/tokenStorage'
import { logSsoLogout } from '@/apis/userAuthApi'
import { decodeJwtPayload } from '@/utils/jwtUtils'
import { Role } from '@/constants/appConstants'

/** Role `super_admin` trên JWT (auth-backend cấp) — BE vẫn chặn bằng `@Roles(SuperAdmin)`. */
export const isSuperAdmin = (): boolean => {
  const token = tokenStorage.getAccessToken()
  const role = token ? decodeJwtPayload(token)?.role : undefined
  if (typeof role === 'string') return role === Role.SuperAdmin
  return profileStorage.getProfile()?.role === Role.SuperAdmin
}

export const isLoggedIn = (): boolean => {
  return tokenStorage.hasValidTokens()
}

export const getAccessToken = (): string | null => {
  return tokenStorage.getAccessToken()
}

export const logout = (): void => {
  const done = () => {
    tokenStorage.clearTokens()
    profileStorage.clearProfile()
    window.location.replace('/login')
  }
  if (!tokenStorage.getAccessToken()) {
    done()
    return
  }
  // Ghi nhật ký đăng xuất; lỗi/timeout vẫn đăng xuất bình thường.
  logSsoLogout().then(done, done)
}
